import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';

@Component({
    selector: 'joint-ownership',
    templateUrl: './joint-ownership.component.html',
    styleUrls: ['./joint-ownership.component.scss'],
    standalone: false
})
export class JointOwnershipComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  pledge: PledgeRead;
  sessionConsultant: boolean;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade?.getPledge();
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
